import React, { useEffect, useState, useCallback } from 'react';
import { Icon } from '@iconify/react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const UnitCountOneVolunteer = () => {
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const [data, setData] = useState({
        total: 0,
        male: 0,
        female: 0,
        other: 0,
    });
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_BASE_URL}/backend/volunteers/get-gender-wise-count`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const result = await response.json();
                if (result.status) {
                    const counts = {
                        total: result.data.Male + result.data.Female + result.data.Other,
                        male: result.data.Male,
                        female: result.data.Female,
                        other: result.data.Other,
                    };
                    setData(counts);
                }
            } else {
                console.error('Failed to fetch data:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [API_BASE_URL]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const statusCards = [
        {
            title: "Total",
            value: data.total,
            icon: "mdi:counter",
            bgColor: "bg-secondary",
            cardClass: "bg-gradient-start-6"
        },
        {
            title: "Male",
            value: data.male,
            icon: "mdi:human-male",
            bgColor: "bg-info",
            cardClass: "bg-gradient-start-3"
        },
        {
            title: "Female",
            value: data.female,
            icon: "mdi:human-female",
            bgColor: "bg-pink",
            cardClass: "bg-gradient-start-2"
        },
        {
            title: "Other",
            value: data.other,
            icon: "mdi:gender-transgender",
            bgColor: "bg-success-main",
            cardClass: "bg-gradient-start-4"
        }
    ];

    return (
        <div className="row row-cols-xxxl-4 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 gy-4">
            {loading ? (
                Array.from({ length: 4 }).map((_, index) => (
                    <div className="col" key={index}>
                        <div className="card shadow-none border bg-gradient-start-3 h-100">
                            <div className="card-body p-20">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                    <div>
                                        <Skeleton width={80} height={20} />
                                        <Skeleton width={50} height={24} />
                                    </div>
                                    <Skeleton circle width={50} height={50} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                statusCards.map((card, index) => (
                    <div className="col" key={index}>
                        <div className={`card shadow-none border ${card.cardClass} h-100`}>
                            <div className="card-body p-20">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                    <div>
                                        <p className="fw-medium text-primary-light mb-1">{card.title}</p>
                                        <h6 className="mb-0">{card.value}</h6>
                                    </div>
                                    <div className={`w-50-px h-50-px ${card.bgColor} rounded-circle d-flex justify-content-center align-items-center`}>
                                        <Icon icon={card.icon} className="text-white text-2xl mb-0" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default UnitCountOneVolunteer;